import { render, staticRenderFns } from "./LegacyExperiments.vue?vue&type=template&id=b3b8a7e0"
import script from "./LegacyExperiments.vue?vue&type=script&lang=js"
export * from "./LegacyExperiments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports